module.exports = __webpack_public_path__ + "img/quickblue_smartphone.4c45031b.png";